import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
    get () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route`, AUTH_HEADERS())
    },
    getArchived () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/archived`, AUTH_HEADERS())
    },
    getById (id) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/${id}`, AUTH_HEADERS())
    },
    getActiveRange(keywords, limit, offset) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/activeRange?keywords=${keywords}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
    },
    getArchivedRange(keywords, limit, offset) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/archivedRange?keywords=${keywords}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
    },
    getTaskRouteNumbers () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/routeNumbers`, AUTH_HEADERS())
    },
    getRouteLocations () {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/routeLocations`, AUTH_HEADERS())
    },
    getIsolatedRouteLocations (id) {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/routeLocations/${id}`,  AUTH_HEADERS())
    },
    create(route) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Route/create`, route, AUTH_HEADERS())
    },
    update (route) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Route/${route.id}`,  route , AUTH_HEADERS())
    },
    delete(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Route/delete/${id}`, id, AUTH_HEADERS())
    },
    archive(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Route/archive/${id}`, id, AUTH_HEADERS())
    },
    complete(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Route/complete/${id}`, id, AUTH_HEADERS())
    },
    restore(id) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Route/restore/${id}`, id, AUTH_HEADERS())
    },
    addUsersToRoute (userId, routeId) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Route/${routeId}/user/${userId}/add`, { routeId: routeId, userId: userId }, AUTH_HEADERS())
    },
    removeUsersFromRoute (userId, routeId) {
        return axios.post(`${process.env.VUE_APP_BASE_URL}Route/${routeId}/user/${userId}/remove`, { routeId: routeId, userId: userId }, AUTH_HEADERS())
    },
    getActiveCount() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/activeCount`, AUTH_HEADERS())
    },
    getArchivedCount() {
        return axios.get(`${process.env.VUE_APP_BASE_URL}Route/archivedCount`, AUTH_HEADERS())
    },
    assignTasks(routeId, taskIds) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Route/${routeId}/assignTasks`, taskIds, AUTH_HEADERS())
    },
    clearTasks(routeId) {
        return axios.put(`${process.env.VUE_APP_BASE_URL}Route/${routeId}/clearTasks`, {}, AUTH_HEADERS())
    },
}
